<template>
  <div>
    <h1>員工</h1>
    <Row :gutter="16">
      <Col span="3">
        <h2>員工人數: {{ page.totalCount }} 人</h2>
      </Col>
      <Col span="4">
        <Input
          search
          enter-button
          placeholder="輸入工號查詢"
          v-model="jobNumberSearch"
          :value="jobNumberSearch"
          @on-enter="searchKeyWord()"
          @on-search="searchKeyWord()"
        />
      </Col>
      <Col span="4">
        <div class="btnGroup">
          <Button @click="clearKeyword()" type="error">
            清除關鍵字
          </Button>
        </div>
      </Col>
      <Col span="4">
        <div class="btnGroup">
          <Button @click="toEditEmployee" type="primary">
            <Icon type="md-add" />員工
          </Button>
        </div>
      </Col>
    </Row>

    <Table
      stripe
      border
      :columns="columns"
      :data="employees"
      :no-data-text="noDataText"
      :no-filtered-data-text="noFilteredDataText"
      @on-row-click="showInfo"
    >
      <template slot-scope="{ row }" slot="timeRangeArray">
        <span v-for="(item, index) in row.timeRangeArray" :key="index"
          >{{ item }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="authorize">
        <span>{{ row.authorize ? "開" : "關" }} </span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button type="warning" size="small">修改密碼</Button>
      </template>
    </Table>
    <div class="paginationContainer page-position">
      <Page
        :total="page.totalCount"
        :curent="page.index"
        :page-size="page.size"
        @on-change="changePage"
      />
    </div>
    <Modal
      v-model="isShowPasswordModal"
      title="修改密碼"
      @on-ok="submitPassword"
      @on-cancel="cancel"
    >
      <Input
        type="password"
        v-model="employeeNewPassword"
        placeholder="請輸入新密碼"
      />
    </Modal>
  </div>
</template>
<script>
import API from "../asset/js/API";
import { checkAuthorize } from "../asset/js/authorize";

export default {
  created() {
    this.getEmployeeList();
  },
  data() {
    return {
      columns: [
        {
          title: "姓名",
          key: "name"
        },
        {
          title: "處",
          key: "division"
        },
        {
          title: "部門",
          key: "department"
        },
        {
          title: "課",
          key: "section"
        },
        {
          title: "工號",
          key: "jobNumber"
        },
        {
          title: "可搭乘時段",
          slot: "timeRangeArray",
          width: 110
        },
        {
          title: "支付限制（金額/趟)",
          key: "payLimit"
        },
        {
          title: "搭乘限制（趟次/月)",
          key: "takingLimit"
        },
        {
          title: "權限",
          slot: "authorize"
        },
        {
          title: "動作",
          slot: "action",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      if (!checkAuthorize("editEmployee")) return;

                      this.isShowPasswordModal = true;
                      this.employeeId = params.row.id;
                    }
                  }
                },
                "修改密碼"
              )
            ]);
          }
        }
      ],
      employees: [
        {
          id: "",
          name: "",
          department: "",
          jobNumber: "",
          startTime1: null,
          endTime1: null,
          startTime2: null,
          endTime2: null,
          startTime3: null,
          endTime3: null,
          payLimit: null,
          takingLimit: null,
          authorize: null,
          timeRange1: "",
          timeRange2: "",
          timeRange3: "",
          timeRangeArray: []
        }
      ],
      page: {
        totalCount: 0,
        index: 1,
        size: 25
      },
      jobNumberSearch: "",
      isShowPasswordModal: false,
      employeeId: null,
      employeeNewPassword: null,
      noDataText: "暫無資料",
      noFilteredDataText: "暫無篩選結果資料"
    };
  },
  methods: {
    toEditEmployee() {
      if (!checkAuthorize("addEmployee")) return;
      this.$router.push({ name: "EditEmployee" });
    },
    showInfo(row, index) {
      if (!checkAuthorize("inspectEmployee")) return;
      this.$router.push(`employeeinfo/${row.id}`);
    },
    searchKeyWord() {
      this.getEmployeeList();
    },
    changePage(page) {
      this.page.index = page;
      this.getEmployeeList();
    },
    clearKeyword() {
      this.jobNumberSearch = "";
      this.getEmployeeList();
    },
    getEmployeeList() {
      if (!checkAuthorize("inspectEmployee")) return;
      API.get(
        `/employee/?npp=${this.page.size}&page=${this.page.index}&keyword=${
          this.jobNumberSearch
        }`
      )
        .then(res => {
          this.employees = res.result.list;
          this.page.totalCount = res.result.count;
          this.mergeTime();
        })
        .catch(err => {
          console.error("取得員工列表", err);
        });
    },
    mergeTime() {
      // 合併開始時間和結束時間成ㄧ字串
      this.employees.forEach(function(employee) {
        // 若有 null 值，用空字串取代
        employee.timeRange1 = `${employee.startTime1} ~ ${
          employee.endTime1
        } / `;
        employee.timeRange2 = `${employee.startTime2} ~ ${
          employee.endTime2
        } / `;
        employee.timeRange3 = `${employee.startTime3} ~ ${
          employee.endTime3
        } / `;

        if (!employee.startTime1 || !employee.endTime1) {
          employee.timeRange1 = "";
        }
        if (!employee.startTime2 || !employee.endTime2) {
          employee.timeRange2 = "";
        }
        if (!employee.startTime3 || !employee.endTime3) {
          employee.timeRange3 = "";
        }
        employee.timeRangeArray = [
          employee.timeRange1,
          employee.timeRange2,
          employee.timeRange3
        ];
      });
    },
    submitPassword() {
      if (!this.employeeNewPassword) {
        this.$Message.info("請填入密碼");
        return;
      }
      API.put(`/employee/${this.employeeId}/pw`, {
        password: this.employeeNewPassword
      })
        .then(res => {
          this.$Message.info("密碼已修改");
        })
        .catch(err => {
          this.$Message.info(`密碼修改失敗:${err}`);
        });
      this.employeeNewPassword = null;
    },
    cancel() {
      this.employeeNewPassword = null;
      this.$Message.info("取消修改");
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/base.scss";
@import "@/scss/pagination.scss";

.btnGroup {
  margin-bottom: 24px;
}

// 修改 iview table css，滑鼠移到 table row 時出現手指
.ivu-table-row {
  cursor: pointer;
}
.page-position {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/EmployeeList.vue